/**
 * Etiquetas compartidas por la tabla y el modal de detalle.
 */

/**
 * OJO: no sirve un ternario sobre `success`, hay que distinguir false de null.
 *
 * Y "Aceptado" no es "Entregado": success=true solo significa que Twilio
 * recibio el mensaje y lo encolo. Los fallos de entrega posteriores (numero
 * sin WhatsApp, plantilla no aprobada, ventana de 24h) llegan asincronos y hoy
 * no se registran en ningun lado.
 */
export const ESTADO = (valor) => {
  if (valor === true || valor === 1) {
    return { label: "Aceptado", color: "success" };
  }
  if (valor === false || valor === 0) {
    return { label: "Falló", color: "danger" };
  }
  return { label: "Pendiente", color: "warning" };
};

/** Espejo de los `context` que escriben los servicios de envio del backend. */
export const CONTEXTOS = {
  reporte_diario_concesionario: "Reporte diario · concesionario",
  reporte_diario_concesionario_sin_salidas:
    "Reporte diario · concesionario (sin salidas)",
  reporte_diario_concesionario_pasaje: "Reporte pasaje · concesionario",
  reporte_diario_concesionario_pasaje_sin_salidas:
    "Reporte pasaje · concesionario (sin salidas)",
  reporte_diario_superadmin: "Reporte diario · SuperAdmin",
  reporte_diario_reseller: "Reporte diario · Reseller",
  reporte_diario_admin: "Reporte diario · Admin de ruta",
  reporte_medio_dia_admin: "Reporte medio día · Admin de ruta",
  validacion_pin: "Validación de PIN",
};

export const etiquetaContexto = (context) => {
  if (!context) return "-";
  return CONTEXTOS[context] ?? context;
};

/**
 * `response` puede ser JSON (respuesta de Twilio) O el texto plano de una
 * excepcion. Un JSON.parse sin guardia tumbaria el modal, con la ironia de que
 * ese crash acabaria en la otra bitacora.
 */
export const formatJson = (valor) => {
  if (!valor) return "-";
  try {
    return JSON.stringify(JSON.parse(valor), null, 2);
  } catch (e) {
    return String(valor);
  }
};
